import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.select2eInstance = $(this.element).select2()
  }
}
